<template>
  <div :class="$style.transfer">
    <a title="乐游游推荐" href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkxODMwODU4Ng==&scene=124#wechat_redirect"></a>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
    };
  },
  methods: {
  }
}
</script>

<style lang="scss" module>
.transfer {
  width: 100%;
  height: 100%;
  > a {
    display: block;
    background: url('//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/transfer.jpg') no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
  }
}
</style>